import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FInter, FlexBox, GridBox, useBreakpoint, useToasts } from '@brg/ui';
import { API, Competition, Endpoints, Lang, LangObject, Tag } from '@brg/api';
import { useTranslation } from 'react-i18next';
import { LayoutConst, ModalControllerContainer } from 'core';
import { AppTester } from 'supporting';
import { 
    Wrapper , 
    ContentContainer,
    MainTitle, 
} from '../styles';
import { CompetitionCommonForm } from './components/CompetitionCommonForm';
import { LegendBadge } from './style';
import { LabelRedStar } from 'shared/pages/designerEditView/styles';
import urlApi from 'shared/actions/urlApi';
import { getCookie } from 'shared/helpers/cookies';
import { ADDITIONAL_COOKIES, parseSbjsCookie, parseUtmFromEp } from './components/CompetitionNewForm/support/support';

export const CompetitionLegalsModal: FC<{
    projects: string[],
    nominationIds: string[],
    competitionId?: string,
    callback: () => void,
    hasDocuments?: boolean,
    isPreRegistration?: boolean,
    registrationDeadline?: string,
    hideProject?: boolean
    }> =
    ({ projects, nominationIds, hasDocuments, isPreRegistration, registrationDeadline, competitionId, callback, hideProject = false }) => {
    const { t, i18n: { language } } = useTranslation();
    const { error } = useToasts();
    const isCGRave = AppTester.isCGRAVE();
    const isMobile = useBreakpoint(LayoutConst.screen.s -1 );
    const [projectsId, setProjectId] = useState<string[]>([]);

    const isGeo = AppTester.isGeograffee();

    useEffect(() => {
        if (projects) {
          setProjectId(projects)
        }
    },[projects])

    const renderOldForm = useMemo(() => {
        if (AppTester.isDaMuseum()) return true;

        return !!competitionId && !![
            '1d3562abcb02489bb7b18379aeaf40b9', //small shorts
            'e25c7245287548188be20de82b93a365', 
            '111a74097f0948dfb50b5258676fb5d3', 
            '5e0f05e63e8b4122931caf06bf824beb',

            '6de0169b71524f1e907be27c8336f4ec', 
            '320687b8bc604aaab9813a2da2fbb163', 
            '158af43dae6c4874961f5f7687df1619', 
            'e4ad76cc870c4d789515747b34c16c76',
            '65c4b2d0ff4347d5b2aedeed57ea1874',
            'f27288337dbf4989888d800ac226a44f', // New World
            '5f43aa857e134ff38954723e01fcbbb9', // Архи-Книга
            'e7da5f11a1284d09b10c50e59e4f338e', // Vega
            "a5acf76614644e068c6fbcdb0b591234", // Анимация, CGI и визуальные эффекты
            "1b34d2608c4b44a4bada28415d6e0ac7", // Гейм-дизайн
            "b6f67510292548a48116544865c413bb", // Дизайн и программирование
            "00503517a6ae494795391cf099b5324f", // Дизайн и продвижение цифрового продукта
            "ce8c14eb587e478bb06af29741749526", // Дизайн и современное искусство
            "86bea52810a74ec5aed370b40c287921", // Коммуникационный дизайн
            "0fb5c9c4152649a1bfad776cc4f1b113", // Дизайн среды и интерьера
            "625a684c2aad45d7ad535ea008be178e", // Игровая графика и концепт-арт
            "35442ed955ba43b78cb04519e0c9eb9e", // Иллюстрация и комикс
            "9a2f9bd90c6c450b816540fd95ddadbf", // Медиа и дизайн
          
            // Москва — Мода
            "e67c65f120a949f6a40e355f8603c889", // Брендинг в индустрии моды
            "e759fe71b56d444ab4567cb73670a7ee", // Дизайн одежды
          
            // Москва — Разработка игр и цифровых продуктов
            "cadb632aa0c0445b928d2266eaba8d48", // Разработка игр и цифровых продуктов
          
            // Санкт-Петербург — Дизайн
            "2fd496b9cf5b4c1292d9a69e5d6c57ee", // Коммуникационный дизайн
            "395f58bdbcac4321a76db6b939633280", // Дизайн среды и интерьера
            "f8e41518de784c03b1f1d8a2ff72f2ee", // Дизайн одежды
            "865c7ac3edb8402e8ed42f55de876941", // Дизайн цифрового продукта
            "099b992943164e578d1eb4e7c95b47b4", // Современная иллюстрация
            "0d605869d89f4540ace34758cb16c8ea", // Communication Design (англ.)
          
            // Санкт-Петербург — Архитектура
            "763e779be98e49b081081911465ed096", // Архитектура
          
            // Нижний Новгород — Дизайн
            "a06d8c9452cd4f5189d5b786dc33714b", // Коммуникационный дизайн
            "21481ea468114610b7bc85575d8b2b09", // UX/UI и frontend-разработка
            "468a5d01f32940d9a77602b4ec64d9d8", // Дизайн среды и интерьера
          
            // Онлайн (Пермь)
            "d638b951f780441ebc30f1fefe335db9", // 3D-постпродакшн
            "57d23b8720374ac7b950958430842364", // Дизайн среды и интерьера
            "f8aed1e5209a4d0d8673c1b23d7a544c", // Дизайн и продвижение цифрового продукта
            "d399519f8c514dc59943e9cce318ac38", // Дизайн и программирование
            "b04fd8720e5443c9ac28f5788e2b146e", // Анимация и иллюстрация
            "8bceccf9f3034982bebd4c8f862e6e2b", // Гейм-дизайн
            "9e08fb787e5943fdb42003722f369380", // Коммуникационный дизайн
            "d29c5182e3d3470eb85de5e34fbf02b4", // Дизайн и современное искусство
        ]?.includes(competitionId);
    }, [competitionId])

    const getUtmParams = () => {
        const utmTags: Record<string, string> = {};
    
        const sbjsCurrent = parseSbjsCookie("sbjs_current_add");
        const utmFromEp = parseUtmFromEp(sbjsCurrent.ep);
        Object.assign(utmTags, utmFromEp);
    
        ADDITIONAL_COOKIES.forEach((cookieName) => {
          const cookieValue = getCookie(cookieName);
          if (cookieValue) {
            utmTags[cookieName] = cookieValue;
          }
        });
    
        return utmTags;
      };

    const onSaveNewFormClick = useCallback(
        (data: any) => {
          if (data) {
            const formId = data.formId;
            const formAnswerFields = data.fields;
    
            try {
              API.request()
                .endpoint(Endpoints.geograffee)
                .url("/api/forms/AddFormAnswer")
                .post()
                .body({
                  formId: formId,
                  utmTags: [""],
                  pageUrl: ``,
                  formAnswerFields: formAnswerFields,
                  metaData: getUtmParams(),
                  isPpdAccepted: false,
                  Language: language,
                  formCompetition: {
                    competitionId: competitionId ?? '',
                    projectId: projectsId?.[0],
                    // nominationId: nominationIds?.[0],
                  }
                })
                .send()
                .then((response) => {
                  if (response?.status === 200) {
                    // setSuccess(true);
                    callback();
                  }
                })
                .catch((error) => {
                  console.error("Error:", error);
                //   setSuccess(false);
                })
                .finally(() => {
                //   submitLockRef.current = false;
                //   setIsSubmiting(false);
                });
            } catch (error) {
              console.error("Error:", error);
            //   setSuccess(false);
            //   submitLockRef.current = false;
            //   setIsSubmiting(false);
            }
          }
        },
        [language, projectsId, competitionId]
      );


    const onSaveClick = useCallback(async(data: any) => {
        if (data) {
            const formData = new FormData()
            const formatted: Record<string, string>[] = Object.entries(data).reduce((acc: any, [key, value]) => {
                if (key === 'projectId' || key === 'nominationId') {
                  return acc;
                }
              
                if (key === 'about_ru' || key === 'about_en' || key === 'projectName_ru' || key === 'projectName_en') {
                  const baseKey = key.endsWith('_ru') ? key.replace('_ru', '') : key.replace('_en', '');
                  const ruKey = `${baseKey}_ru`;
                  const enKey = `${baseKey}_en`;
              
                  if (key === ruKey) {
                    const ruValue = value || '';
                    const enValue = data[enKey] || '';
              
                    acc.push({
                      Title: baseKey,
                      Value: JSON.stringify([
                        { lang: 'Ru', name: ruValue },
                        { lang: 'En', name: enValue }
                      ])
                    });
              
                    delete data[enKey];
                  }
              
                  return acc;
                }
              
                let finalKey = key;
                if (key === 'educationPlace') {
                  finalKey = 'education';
                }
              
                acc.push({
                  Title: finalKey,
                  Value: (typeof value === 'string' || finalKey === 'birthDate') ? value : JSON.stringify(value) 
                  //['about', 'projectName', 'nominationsList', 'hasSubtitles', 'consentToUse', 'consentToDemonstrate', 'consentFile'].includes(finalKey)
                    //? JSON.stringify(value)
                    //: value
                });
              
                return acc;
              }, []);


            const { agreeDocuments, otherFields } = formatted.reduce(
            (acc: any, item) => {
                let processedValue = item.Value;
            
                if (item.Title === 'birthDate' && item.Value) {
                    processedValue = new Date(item?.Value).toISOString().slice(0, 10);
                }
            
                const processedItem = {
                    Title: item.Title,
                    Value: processedValue
                };
            
                if (item.Title.startsWith('agree')) {
                    const toBool = (str: string | null | undefined) => str?.toLowerCase() === 'true';
                    acc.agreeDocuments.push({
                        Name: item.Title,
                        IsSigned: toBool(processedValue)
                    });
                } else {
                    acc.otherFields.push(processedItem);
                }
            
                return acc;
            },
            { agreeDocuments: [], otherFields: [] }
            );

            formData.append('Fields', JSON.stringify(otherFields));
            formData.set('NominationId', JSON.stringify(nominationIds));
            formData.set('ProjectId', projectsId?.[0]);
            formData.set('CompetitionId', competitionId ?? '');
            if (hideProject) {
                formData.set('HideProject', 'true');
            }

            if (agreeDocuments?.length > 0) {
                formData.append('Documents',  JSON.stringify(agreeDocuments))
            }

            try {
                await API.fetch(
                    Endpoints.competitions + '/api/Competition/ApplyNomination', {
                        method: "POST",
                        body: formData 
                })
                .then((r) => {
                    if (r.status === 200) {
                        API.fetch(
                            Endpoints.competitions + '/api/Competition/AddCompetitorFormAnswer', {
                                method: "POST",
                                body: formData 
                        })
                        callback();
                    }
                })
                .catch((e) => error(String(e)))
            }
            catch (e) {
                console.log('ошибка при отправке запроса')
            }
        }
    }, [
        nominationIds, 
        projectsId,
        competitionId,
        t, 
        callback, 
        error
    ]);

    const defaultNominationId = useMemo(() => nominationIds?.[0] , [nominationIds])

    const importantCustomBG = useMemo(() => (isCGRave ? { importantCustomBG: 'rgb(0,0,0)'} : {}) , [isCGRave])

    const isRegistrationDeadlinePassed = useMemo(
        () => !!isPreRegistration && !!registrationDeadline && new Date() > new Date(registrationDeadline),
        [isPreRegistration, registrationDeadline]
    )

    const handleSubmit = useCallback((data: any) => {
        if (isRegistrationDeadlinePassed) {
            error(t('competition.registration_closed'));
            return;
        }
        if (renderOldForm) {
            onSaveClick(data);
        }
        onSaveNewFormClick(data);
    }, [onSaveClick, onSaveNewFormClick, isRegistrationDeadlinePassed, error, t])

    return <ModalControllerContainer {...importantCustomBG}>
        <Wrapper direction='column' style={{ margin: isMobile ? '12px auto' : '88px auto', overflowY: "auto", overflowX: 'hidden' }} isGeo={isGeo} >
            <ContentContainer>
              {renderOldForm && (
                <>
                  <MainTitle>{t('competition.application_form')}</MainTitle>
                  <LegendBadge>
                      <LabelRedStar>*</LabelRedStar>
                      {`${t('competition.legend_badge')}`}
                  </LegendBadge>
                </>
              )}

                <CompetitionCommonForm 
                    competitionId={competitionId ?? ''} 
                    projectId={projectsId[0]} 
                    nominationId={defaultNominationId} 
                    isPreRegistration={isPreRegistration} 
                    onSubmit={handleSubmit} 
                    shouldSignConsent={hasDocuments}
                    renderOldForm={renderOldForm}
                />             
            </ContentContainer>
        </Wrapper>
    </ModalControllerContainer>

};
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FInter, FlexBox, GridBox, useBreakpoint, useToasts } from '@brg/ui';
import { API, Competition, Endpoints, Lang, LangObject, Tag } from '@brg/api';
import { useTranslation } from 'react-i18next';
import { LayoutConst, ModalControllerContainer } from 'core';
import { AppTester } from 'supporting';
import { 
    Wrapper , 
    ContentContainer,
    MainTitle, 
} from '../styles';
import { CompetitionCommonForm } from './components/CompetitionCommonForm';
import { LegendBadge } from './style';
import { LabelRedStar } from 'shared/pages/designerEditView/styles';
import urlApi from 'shared/actions/urlApi';
import { getCookie } from 'shared/helpers/cookies';
import { ADDITIONAL_COOKIES, parseSbjsCookie, parseUtmFromEp } from './components/CompetitionNewForm/support/support';

export const CompetitionLegalsModal: FC<{
    projects: string[],
    nominationIds: string[],
    competitionId?: string,
    callback: () => void,
    hasDocuments?: boolean,
    isPreRegistration?: boolean,
    registrationDeadline?: string,
    hideProject?: boolean
    }> =
    ({ projects, nominationIds, hasDocuments, isPreRegistration, registrationDeadline, competitionId, callback, hideProject = false }) => {
    const { t, i18n: { language } } = useTranslation();
    const { error } = useToasts();
    const isCGRave = AppTester.isCGRAVE();
    const isMobile = useBreakpoint(LayoutConst.screen.s -1 );
    const [projectsId, setProjectId] = useState<string[]>([]);

    const isGeo = AppTester.isGeograffee();

    useEffect(() => {
        if (projects) {
          setProjectId(projects)
        }
    },[projects])

    const renderOldForm = useMemo(() => {
        if (AppTester.isDaMuseum()) return true;

        return !!competitionId && !![
            '1d3562abcb02489bb7b18379aeaf40b9', //small shorts
            'e25c7245287548188be20de82b93a365', 
            '111a74097f0948dfb50b5258676fb5d3', 
            '5e0f05e63e8b4122931caf06bf824beb',

            '6de0169b71524f1e907be27c8336f4ec', 
            '320687b8bc604aaab9813a2da2fbb163', 
            '158af43dae6c4874961f5f7687df1619', 
            'e4ad76cc870c4d789515747b34c16c76',
            '65c4b2d0ff4347d5b2aedeed57ea1874',
            'f27288337dbf4989888d800ac226a44f', // New World
            '5f43aa857e134ff38954723e01fcbbb9', // Архи-Книга
            'e7da5f11a1284d09b10c50e59e4f338e', // Vega
            "a5acf76614644e068c6fbcdb0b591234", // Анимация, CGI и визуальные эффекты
            "1b34d2608c4b44a4bada28415d6e0ac7", // Гейм-дизайн
            "b6f67510292548a48116544865c413bb", // Дизайн и программирование
            "00503517a6ae494795391cf099b5324f", // Дизайн и продвижение цифрового продукта
            "ce8c14eb587e478bb06af29741749526", // Дизайн и современное искусство
            "86bea52810a74ec5aed370b40c287921", // Коммуникационный дизайн
            "0fb5c9c4152649a1bfad776cc4f1b113", // Дизайн среды и интерьера
            "625a684c2aad45d7ad535ea008be178e", // Игровая графика и концепт-арт
            "35442ed955ba43b78cb04519e0c9eb9e", // Иллюстрация и комикс
            "9a2f9bd90c6c450b816540fd95ddadbf", // Медиа и дизайн
          
            // Москва — Мода
            "e67c65f120a949f6a40e355f8603c889", // Брендинг в индустрии моды
            "e759fe71b56d444ab4567cb73670a7ee", // Дизайн одежды
          
            // Москва — Разработка игр и цифровых продуктов
            "cadb632aa0c0445b928d2266eaba8d48", // Разработка игр и цифровых продуктов
          
            // Санкт-Петербург — Дизайн
            "2fd496b9cf5b4c1292d9a69e5d6c57ee", // Коммуникационный дизайн
            "395f58bdbcac4321a76db6b939633280", // Дизайн среды и интерьера
            "f8e41518de784c03b1f1d8a2ff72f2ee", // Дизайн одежды
            "865c7ac3edb8402e8ed42f55de876941", // Дизайн цифрового продукта
            "099b992943164e578d1eb4e7c95b47b4", // Современная иллюстрация
            "0d605869d89f4540ace34758cb16c8ea", // Communication Design (англ.)
          
            // Санкт-Петербург — Архитектура
            "763e779be98e49b081081911465ed096", // Архитектура
          
            // Нижний Новгород — Дизайн
            "a06d8c9452cd4f5189d5b786dc33714b", // Коммуникационный дизайн
            "21481ea468114610b7bc85575d8b2b09", // UX/UI и frontend-разработка
            "468a5d01f32940d9a77602b4ec64d9d8", // Дизайн среды и интерьера
          
            // Онлайн (Пермь)
            "d638b951f780441ebc30f1fefe335db9", // 3D-постпродакшн
            "57d23b8720374ac7b950958430842364", // Дизайн среды и интерьера
            "f8aed1e5209a4d0d8673c1b23d7a544c", // Дизайн и продвижение цифрового продукта
            "d399519f8c514dc59943e9cce318ac38", // Дизайн и программирование
            "b04fd8720e5443c9ac28f5788e2b146e", // Анимация и иллюстрация
            "8bceccf9f3034982bebd4c8f862e6e2b", // Гейм-дизайн
            "9e08fb787e5943fdb42003722f369380", // Коммуникационный дизайн
            "d29c5182e3d3470eb85de5e34fbf02b4", // Дизайн и современное искусство
        ]?.includes(competitionId);
    }, [competitionId])

    const getUtmParams = () => {
        const utmTags: Record<string, string> = {};
    
        const sbjsCurrent = parseSbjsCookie("sbjs_current_add");
        const utmFromEp = parseUtmFromEp(sbjsCurrent.ep);
        Object.assign(utmTags, utmFromEp);
    
        ADDITIONAL_COOKIES.forEach((cookieName) => {
          const cookieValue = getCookie(cookieName);
          if (cookieValue) {
            utmTags[cookieName] = cookieValue;
          }
        });
    
        return utmTags;
      };

    const onSaveNewFormClick = useCallback(
        (data: any) => {
          if (data) {
            const formId = data.formId;
            const formAnswerFields = data.fields;
    
            try {
              API.request()
                .endpoint(Endpoints.geograffee)
                .url("/api/forms/AddFormAnswer")
                .post()
                .body({
                  formId: formId,
                  utmTags: [""],
                  pageUrl: ``,
                  formAnswerFields: formAnswerFields,
                  metaData: getUtmParams(),
                  isPpdAccepted: false,
                  Language: language,
                  formCompetition: {
                    competitionId: competitionId ?? '',
                    projectId: projectsId?.[0],
                    // nominationId: nominationIds?.[0],
                  }
                })
                .send()
                .then((response) => {
                  if (response?.status === 200) {
                    // setSuccess(true);
                    callback();
                  }
                })
                .catch((error) => {
                  console.error("Error:", error);
                //   setSuccess(false);
                })
                .finally(() => {
                //   submitLockRef.current = false;
                //   setIsSubmiting(false);
                });
            } catch (error) {
              console.error("Error:", error);
            //   setSuccess(false);
            //   submitLockRef.current = false;
            //   setIsSubmiting(false);
            }
          }
        },
        [language, projectsId, competitionId]
      );


    const onSaveClick = useCallback(async(data: any) => {
        if (data) {
            const formData = new FormData()
            const formatted: Record<string, string>[] = Object.entries(data).reduce((acc: any, [key, value]) => {
                if (key === 'projectId' || key === 'nominationId') {
                  return acc;
                }
              
                if (key === 'about_ru' || key === 'about_en' || key === 'projectName_ru' || key === 'projectName_en') {
                  const baseKey = key.endsWith('_ru') ? key.replace('_ru', '') : key.replace('_en', '');
                  const ruKey = `${baseKey}_ru`;
                  const enKey = `${baseKey}_en`;
              
                  if (key === ruKey) {
                    const ruValue = value || '';
                    const enValue = data[enKey] || '';
              
                    acc.push({
                      Title: baseKey,
                      Value: JSON.stringify([
                        { lang: 'Ru', name: ruValue },
                        { lang: 'En', name: enValue }
                      ])
                    });
              
                    delete data[enKey];
                  }
              
                  return acc;
                }
              
                let finalKey = key;
                if (key === 'educationPlace') {
                  finalKey = 'education';
                }
              
                acc.push({
                  Title: finalKey,
                  Value: (typeof value === 'string' || finalKey === 'birthDate') ? value : JSON.stringify(value) 
                  //['about', 'projectName', 'nominationsList', 'hasSubtitles', 'consentToUse', 'consentToDemonstrate', 'consentFile'].includes(finalKey)
                    //? JSON.stringify(value)
                    //: value
                });
              
                return acc;
              }, []);


            const { agreeDocuments, otherFields } = formatted.reduce(
            (acc: any, item) => {
                let processedValue = item.Value;
            
                if (item.Title === 'birthDate' && item.Value) {
                    processedValue = new Date(item?.Value).toISOString().slice(0, 10);
                }
            
                const processedItem = {
                    Title: item.Title,
                    Value: processedValue
                };
            
                if (item.Title.startsWith('agree')) {
                    const toBool = (str: string | null | undefined) => str?.toLowerCase() === 'true';
                    acc.agreeDocuments.push({
                        Name: item.Title,
                        IsSigned: toBool(processedValue)
                    });
                } else {
                    acc.otherFields.push(processedItem);
                }
            
                return acc;
            },
            { agreeDocuments: [], otherFields: [] }
            );

            formData.append('Fields', JSON.stringify(otherFields));
            formData.set('NominationId', JSON.stringify(nominationIds));
            formData.set('ProjectId', projectsId?.[0]);
            formData.set('CompetitionId', competitionId ?? '');
            if (hideProject) {
                formData.set('HideProject', 'true');
            }

            if (agreeDocuments?.length > 0) {
                formData.append('Documents',  JSON.stringify(agreeDocuments))
            }

            try {
                await API.fetch(
                    Endpoints.competitions + '/api/Competition/ApplyNomination', {
                        method: "POST",
                        body: formData 
                })
                .then((r) => {
                    if (r.status === 200) {
                        API.fetch(
                            Endpoints.competitions + '/api/Competition/AddCompetitorFormAnswer', {
                                method: "POST",
                                body: formData 
                        })
                        callback();
                    }
                })
                .catch((e) => error(String(e)))
            }
            catch (e) {
                console.log('ошибка при отправке запроса')
            }
        }
    }, [
        nominationIds, 
        projectsId,
        competitionId,
        t, 
        callback, 
        error
    ]);

    const defaultNominationId = useMemo(() => nominationIds?.[0] , [nominationIds])

    const importantCustomBG = useMemo(() => (isCGRave ? { importantCustomBG: 'rgb(0,0,0)'} : {}) , [isCGRave])

    const isRegistrationDeadlinePassed = useMemo(
        () => !!isPreRegistration && !!registrationDeadline && new Date() > new Date(registrationDeadline),
        [isPreRegistration, registrationDeadline]
    )

    const handleSubmit = useCallback((data: any) => {
        if (isRegistrationDeadlinePassed) {
            error(t('competition.registration_closed'));
            return;
        }
        if (renderOldForm) {
            onSaveClick(data);
        }
        onSaveNewFormClick(data);
    }, [onSaveClick, onSaveNewFormClick, isRegistrationDeadlinePassed, error, t])

    return <ModalControllerContainer {...importantCustomBG}>
        <Wrapper direction='column' style={{ margin: isMobile ? '12px auto' : '88px auto', overflowY: "auto", overflowX: 'hidden' }} isGeo={isGeo} >
            <ContentContainer>
              {renderOldForm && (
                <>
                  <MainTitle>{t('competition.application_form')}</MainTitle>
                  <LegendBadge>
                      <LabelRedStar>*</LabelRedStar>
                      {`${t('competition.legend_badge')}`}
                  </LegendBadge>
                </>
              )}

                <CompetitionCommonForm 
                    competitionId={competitionId ?? ''} 
                    projectId={projectsId[0]} 
                    nominationId={defaultNominationId} 
                    isPreRegistration={isPreRegistration} 
                    onSubmit={handleSubmit} 
                    shouldSignConsent={hasDocuments}
                    renderOldForm={renderOldForm}
                />             
            </ContentContainer>
        </Wrapper>
    </ModalControllerContainer>

};
